import { Tooltip, TooltipProps } from 'lego-on-react';
import * as React from 'react';
import { ReactNode } from 'react';

import { PopupScopeContext } from '../../service/Dom/Dom';
import { LazyVisible } from '../LazyVisible/LazyVisible';

import './ScopedTooltip.css';

export type TooltipDecoratorProps = TooltipProps & {
    children?: ReactNode;
    cls?: string;
};

export const ScopedTooltip = React.memo((props: TooltipDecoratorProps) => {
    return (
        <PopupScopeContext.Consumer>
            {getScope => {
                const scope = getScope();
                const tooltipProps =
                    scope === null ? props : { scope, ...props };

                return (
                    <LazyVisible>
                        <Tooltip {...tooltipProps}>{props.children}</Tooltip>
                    </LazyVisible>
                );
            }}
        </PopupScopeContext.Consumer>
    );
});
